// extracted by mini-css-extract-plugin
export default {"Footer":"Footer__KCmmB","selected":"selected__1edxt"};